var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i18n',{attrs:{"path":_vm.value.event,"tag":"div"},scopedSlots:_vm._u([{key:"form",fn:function(){return [_c('router-link',{attrs:{"to":{ name: 'form-submit-mutate', params: { id: _vm.value.data.submit } }}},[_vm._v("\n      "+_vm._s(_vm.value.data.title)+"\n    ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }